import type { ReactNode } from "react";
import Card from "../Card/Card";
import "./EmptyState.css";

export interface EmptyStateProps {
  /** shown in a round lime frame, e.g. <Icon name="bell" /> */
  icon?: ReactNode;
  title?: ReactNode;
  /** grey text under the title */
  children?: ReactNode;
  /** e.g. a Button */
  action?: ReactNode;
  className?: string;
}

/**
 * A card that says "nothing here yet" and what to do about it.
 * Same box as Card, so it lines up with the cards around it.
 * Example: <EmptyState icon={<Icon name="bell" />} action={<Button>Send</Button>}>Not done yet</EmptyState>
 */
const EmptyState = ({
  icon,
  title,
  children,
  action,
  className = "",
}: EmptyStateProps) => (
  <Card as="div" className={`ds-empty-state ${className}`.trim()}>
    {icon && <span className="ds-empty-state__icon">{icon}</span>}
    {title && <h3 className="ds-empty-state__title">{title}</h3>}
    {children && <p className="ds-empty-state__text">{children}</p>}
    {action && <div className="ds-empty-state__action">{action}</div>}
  </Card>
);

export default EmptyState;
